export default __webpack_public_path__ + "292a98a4e4b602d2084ebba7a5c3edcf.svg";